import { useRouter } from "next/router";
import Link, { LinkProps } from "next/link";
import React, { PropsWithChildren, useState, useEffect } from "react";
import clx from "classnames";

type ActiveLinkProps = LinkProps & {
    className?: string;
    activeClassName?: string;
    partiallyActive?: boolean;
};

const ActiveLink = ({ children, activeClassName, partiallyActive, className, ...props }: PropsWithChildren<ActiveLinkProps>) => {
    const { asPath, isReady } = useRouter();
    const [computedClassName, setComputedClassName] = useState(className);

    useEffect(() => {
        // Check if the router fields are updated client-side
        if (isReady) {
            // Dynamic route will be matched via props.as
            // Static route will be matched via props.href
            const linkPathname = new URL((props.as || props.href) as string, window.location.href).pathname;

            // Using URL().pathname to get rid of query and hash
            const activePathname = new URL(asPath, window.location.href).pathname;

            const isLinkActive = partiallyActive ? activePathname.startsWith(linkPathname) : activePathname === linkPathname;

            const newClassName = isLinkActive ? clx(className, activeClassName) : className;

            if (newClassName !== computedClassName) {
                setComputedClassName(newClassName);
            }
        }
    }, [asPath, isReady, props.as, props.href, activeClassName, className, computedClassName, partiallyActive]);

    return (
        <Link className={computedClassName} {...props}>
            {children}
        </Link>
    );
};

export default ActiveLink;
